import { render, staticRenderFns } from "./Holidays.vue?vue&type=template&id=2621c6d3&scoped=true&lang=pug"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621c6d3",
  null
  
)

export default component.exports